import { LogOut } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "../site/Logo";

export const AppHeader = ({ onLogout, children, home = "/" }) => (
  <header className="border-b border-white/10 print:hidden">
    <div className="mx-auto flex h-[72px] max-w-[1280px] items-center justify-between gap-4 px-5 md:px-10">
      <Link to={home} data-testid="app-header-home"><Logo compact /></Link>
      <div className="flex items-center gap-5">
        {children}
        <button onClick={onLogout} data-testid="logout-button" className="flex items-center gap-2 text-sm text-[var(--bone-2)] hover:text-[var(--signal)]">
          <LogOut className="h-4 w-4" /> Sign out
        </button>
      </div>
    </div>
  </header>
);
